export default "__VITE_ASSET__BccBKBu$__"